export default __webpack_public_path__ + "static/media/threeDotsHCSelected.fd865ab2.svg";